export const FORMS_READ = 'forms-read';
export const FORMS_WRITE = 'forms-write';
export const LANDINGPAGES_ACCESS = 'landingpages-access';
export const BLOG_ACCESS = 'blog-access';
export const SITEPAGES_ACCESS = 'sitepages-access';
export const CRM_EXPORT = 'crm-export';
export const CRM_PRODUCT = 'crm-product';
export const CRM_SECONDARY_PERMISSIONS = 'crm-secondary-permissions';
export const FORM_SUBMISSION_EMAIL_DOMAIN_BLOCKING_ACCESS = 'form-submission-email-domain-blocking-access';
export const FORM_V2_TEMP = 'forms-v2-temp';
export const FORMS_DEPENDENT_FIELDS_ACCESS = 'forms-dependent-fields-access';
export const FORMS_PROGRESSIVE_PROFILING_ACCESS = 'forms-progressive-profiling-access';
export const FORMS_SMART_FIELDS_ACCESS = 'forms-smart-fields-access';
export const FORMS_RAW_HTML_ACCESS = 'forms-raw-html-access';
export const FORMS_SUBMISSION_NOTIFICATIONS = 'forms-submission-notifications';
export const LEADIN_NO_BRANDING = 'leadin-no-branding';
export const HUB_MARKETING_PRODUCT = 'hub-marketing-product';
export const MARKETING_FREE_PRODUCT = 'marketing-free-product';
export const MARKETING_STARTER_PRODUCT = 'marketing-starter-product';
export const CUSTOM_STYLE = 'form-custom-style';
export const EMAIL_WRITE = 'email-publish';
export const TEAMS_FORM_PARTITIONING = 'teams-form-partitioning';
export const CONTENT_TEAM_ASSIGNMENT = 'content-team-assignment';
export const EMAIL_SENDING_FREE = 'email-sending-free';
export const EMAIL_SENDING_STARTER = 'email-sending-starter';
export const LANDINGPAGES_REPORT_ACCESS = 'landingpages-report-access';
export const CONVERSATIONS_ADMIN = 'conversations-admin';
export const CAN_SPAM_SETTINGS_ACCESS = 'can-spam-settings-access';
export const MARKETABLE_CONTACTS_ACCESS = 'marketable-contacts-access';
export const MARKETABLE_CONTACTS_WRITE = 'marketable-contacts-write';
export const COMPARISON_TOOL_ACCESS = 'comparison-tool-access';
export const ADDITIONAL_BRAND_DOMAINS = 'additional-brand-domains';
export const BUSINESS_UNITS_ACCESS = 'business-units-access';
export const CAMPAIGNS_ACCESS = 'campaigns-access';
export const CAMPAIGNS_WRITE = 'campaigns-write';
export const PAYMENT_LINKS_READ = 'payment-links-read';
export const PAYMENTS_ELIGIBLE = 'payments-eligible';
export const CONTACTS_READ = 'contacts-read';
export const ROUTING_ACCESS = 'forms-routing-access';
export const DATA_PRIVACY_CONSENT_READ = 'data-privacy-consent-read';
export const HELP_DESK_ACCESS = 'help-desk-access';
export const NEW_EDITOR_CUSTOM_STYLING = 'hubspot-forms-custom-styling';
export const NEW_EDITOR_MULTI_STEP = 'hubspot-forms-multi-step';